import styled from 'styled-components';

export const FooterMenu = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
  gap: 10px;
`;

export const Footer2Menu = styled.ul`
  padding: 0;
  list-style: none;

  & > li {
    margin-bottom: 10px;
  }
`;
export const FooterContainer = styled.div `
position: relative;
height: unset;
background: white;
border-radius: 20px;
padding: 8px 16px 8px 16px;
box-sizing: border-box;
cursor: pointer;
display: flex;
-webkit-box-pack: justify;
justify-content: space-between;
-webkit-box-align: center;
align-items: center;
border-bottom: 5px solid #396AE8;
box-shadow: rgb(80 80 80 / 10%) 0px 0px 24px;
`;

export const FooterContainerMessage =styled.div `
    font-size: 16px;
    margin-right: 10px;
    //margin-bottom: 6px;
    width: 100%;
`;
export const FooterContainerIconFrame = styled.div`
//background: #f1f1f1;
border-radius: 20px;
padding-top: 10px;
padding-bottom: 10px;
padding-left: inherit;
display: flex;
align-self: flex-end;

`;
export const MessageContent = styled.div`
cursor: pointer;
color: #303030;
//margin-top: 6px;
word-break: break-word;
font-size: 15px;
line-height: 20px;
//opacity: 0.8;
max-height: 60px;
max-width: 240px;
padding-right: 2px;
display: -webkit-box;
-webkit-line-clamp: 3;
-webkit-box-orient: vertical;
overflow: hidden;
white-space: pre-wrap;
`;

export const FooterTop = styled.section`
  background-color: ${({ theme }) => theme.backgroundColors['secondary']};
  padding: 40px 0;
  background-image: url('/city-lawyers/images/footer-pattern.png');
  background-repeat: no-repeat;
  background-position: right bottom;
  margin-top: -20px;
`;

export const Footer = styled.footer`
  background-color: ${({ theme }) => theme.backgroundColors['darkBlue']};
  padding: 40px 0;
  margin-top:-15px;
  a {
    color: #4c95d3;
  }
`;

export const FloatingGreeting = styled.div`
  position: fixed;
  right: 0.75rem;
  bottom: 4.75rem;
  z-index: 70;
  max-width: 215px;
  width: 215px;
`;
export const FloatingButton = styled.div`
  position: fixed;
  right: 0.75rem;
  bottom: 4.75rem;
  padding: 0.5rem;
  box-shadow:1px 1px 4px 4px #ccc;
  background-color: ${({ theme }) => theme.backgroundColors['white']};
  border-radius: 50%;
  height: 3rem;
  width: 3rem;
  z-index: 9999;
`;
